/**
 * Bumped whenever simulation behaviour changes. Co-op peers and replays must match exactly.
 */
export const SIM_VERSION = '0.50.0';

/** Simulation steps per real second at 1x speed. */
export const TICKS_PER_SECOND = 20;

/** Game seconds that pass per tick: at 1x, one real second is one game minute. */
export const GAME_SECONDS_PER_TICK = 3;
export const TICKS_PER_GAME_MINUTE = 60 / GAME_SECONDS_PER_TICK;
export const TICKS_PER_GAME_HOUR = 60 * TICKS_PER_GAME_MINUTE;
export const TICKS_PER_GAME_DAY = 24 * TICKS_PER_GAME_HOUR;

/** The game clock starts at 08:00 on day 1. */
export const START_MINUTE_OF_DAY = 8 * 60;

/** Edge length of a render chunk, in tiles. */
export const CHUNK_SIZE = 16;

/** Edge length of a purchasable land parcel, in tiles. */
export const PARCEL_SIZE = 32;

/** Parcels owned at the start: a centred block of this many parcels. */
export const START_PARCELS_X = 3;
export const START_PARCELS_Y = 2;

/** Constructions and upgrades that can run at the same time. */
export const CONSTRUCTION_CREWS = 2;

/** Longest line, in tiles, that a single network command may draw. */
export const MAX_COMMAND_SPAN = 128;

/** Co-op peers exchange a state hash every this many bundles. */
export const HASH_INTERVAL = 20;

export const DEFAULT_MAP_WIDTH = 256;
export const DEFAULT_MAP_HEIGHT = 256;
